//  let slideUp = (target, duration=500) => {
//     target.style.transitionProperty = 'height, margin, padding';
//     target.style.transitionDuration = duration + 'ms';
//     target.style.boxSizing = 'border-box';
//     target.style.height = target.offsetHeight + 'px';
//     target.offsetHeight;
//     target.style.overflow = 'hidden';
//     target.style.height = 0;
//     target.style.paddingTop = 0;
//     target.style.paddingBottom = 0;
//     target.style.marginTop = 0;
//     target.style.marginBottom = 0;
//     window.setTimeout( () => {
//       target.style.display = 'none';
//       target.style.removeProperty('height');
//       target.style.removeProperty('padding-top');
//       target.style.removeProperty('padding-bottom');
//       target.style.removeProperty('margin-top');
//       target.style.removeProperty('margin-bottom');
//       target.style.removeProperty('overflow');
//       target.style.removeProperty('transition-duration');
//       target.style.removeProperty('transition-property');
//     }, duration);
//   }

//   let slideDown = (target, duration=500) => {
//     target.style.removeProperty('display');
//     let display = window.getComputedStyle(target).display;

//     if (display === 'none')
//       display = 'block';

//     target.style.display = display;
//     let height = target.offsetHeight;
//     target.style.overflow = 'hidden';
//     target.style.height = 0;
//     target.style.paddingTop = 0;
//     target.style.paddingBottom = 0;
//     target.style.marginTop = 0;
//     target.style.marginBottom = 0;
//     target.offsetHeight;
//     target.style.boxSizing = 'border-box';
//     target.style.transitionProperty = "height, margin, padding";
//     target.style.transitionDuration = duration + 'ms';
//     target.style.height = height + 'px';
//     target.style.removeProperty('padding-top');
//     target.style.removeProperty('padding-bottom');
//     target.style.removeProperty('margin-top');
//     target.style.removeProperty('margin-bottom');
//     window.setTimeout( () => {
//       target.style.removeProperty('height');
//       target.style.removeProperty('overflow');
//       target.style.removeProperty('transition-duration');
//       target.style.removeProperty('transition-property');
//     }, duration);
//   }
//   var slideToggle = (target, duration = 500) => {
//     if (window.getComputedStyle(target).display === 'none') {
//       return slideDown(target, duration);
//     } else {
//       return slideUp(target, duration);
//     }
//   }

// function readlessmore() {
//     var moreDescription = document.getElementById("moredescription");
//     var linkText = document.getElementById("moreless-link");
//     slideToggle(moreDescription, 500);

//     if (linkText.innerHTML === "Read more") {
//         linkText.innerHTML = "Read less";
//     } else {
//         linkText.innerHTML = "Read more";
//     }
//   }


// /* Collection CMS (Efficient Metrics) */
// window.themeObj = {};

// window.themeObj.collectionPage = {
//   init: function() {

//     if (document.querySelector('.collection-template-cms__data')) {
//       window.themeObj.collectionCmsPage.init();
//     }

//     setInterval(function() {
//       const collectionHeading = document.querySelector('.CollectionFilters__Heading');

//       console.log('collectionHeading', collectionHeading);
    
//       if (!collectionHeading) {
//         const collectionHeadingText = document.querySelector('.CollectionTitle__Content').getAttribute('data-title');
//         const collectionSidebar = document.getElementById('searchspring-sidebar');
        
//         const newCollectionHeading = document.createElement('h1');
//         newCollectionHeading.setAttribute('class', 'CollectionFilters__Heading Heading u-h1');
//         newCollectionHeading.innerHTML = collectionHeadingText;
//         collectionSidebar.appendChild(newCollectionHeading);

//         const products = document.querySelector('.CollectionInner__Products');
//         products.setAttribute('data-title', collectionHeadingText);
//       }
//     }, 1000);
//   }
// };

// window.themeObj.collectionCmsPage = {
//   init: function() {
//     const queryOptions = {
//       method: 'GET',
//       credentials: 'same-origin'
//     };
//     const collectionData = document.querySelector('.collection-template-cms__data');
//     const collectionCmsQuery = collectionData.getAttribute('data-cms-query');
  
//     const queries = [
//       fetch(collectionCmsQuery, queryOptions)
//     ];

//     Promise.all(queries).then(function (responses) {
  
//       Promise.all(responses.map(function (response) {
//         return response.text();
//       })).then(function (ajaxContents) {
//         const ajaxContent = document.createElement('div');
//         ajaxContent.innerHTML = ajaxContents[0].trim();

//         if (/^\/collections\/.+/.test(collectionCmsQuery)) {
//           window.themeObj.collectionCmsPage.filters(ajaxContent);
//           window.themeObj.collectionCmsPage.sorting(ajaxContent);
//           window.themeObj.collectionCmsPage.products(ajaxContent);
          
//         } else {
//           const products = document.querySelector('#searchspring-content');
//           const ajaxProducts = ajaxContent.querySelector('#searchspring-content');
    
//           if (products && ajaxProducts) {
//             const ajaxProductsCells = ajaxProducts.querySelectorAll('.ProductList > .Grid__Cell');

//             for (var i = 0; i < ajaxProductsCells.length; i++) {
//               const ajaxProductCell = ajaxProductsCells[i];
//               ajaxProductCell.classList.remove('1/1--phone');
//               ajaxProductCell.classList.add('1/2--phone');
              
//               const ajaxProductItem = ajaxProductCell.querySelector('.ProductItem');
//               ajaxProductItem.style.visibility = 'inherit';
//               ajaxProductItem.style.opacity = 1;
//               ajaxProductItem.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
//             }

//             products.innerHTML = ajaxProducts.innerHTML;
//             document.dispatchEvent(new CustomEvent('theme:loading:end'));
//           }
//         }
        
//         document.dispatchEvent(new CustomEvent('theme:loading:end'));
//       });
//     });
//   },
//   filters: function(ajaxContent) {
//     const collectionData = document.querySelector('.collection-template-cms__data');
    
//     const filterDrawer = document.querySelector('#collection-filter-drawer');
//     const ajaxFilterDrawer = ajaxContent.querySelector('#collection-filter-drawer');

//     if (filterDrawer && ajaxFilterDrawer) {
//       filterDrawer.innerHTML = ajaxFilterDrawer.innerHTML;
//     }
    
//     const toolbar = document.querySelector('#searchspring-toolbar');
//     const ajaxToolbar = ajaxContent.querySelector('#searchspring-toolbar');

//     if (toolbar && ajaxToolbar) {
//       toolbar.innerHTML = ajaxToolbar.innerHTML;
//     }
    
//     const overlay = document.querySelector('.PageOverlay');
    
//     const sidebar = document.querySelector('#searchspring-sidebar');
    
//     const ajaxSidebar = ajaxContent.querySelector('#searchspring-sidebar');
//     ajaxSidebar.querySelector('.CollectionFilters__Heading').innerHTML = collectionData.getAttribute('data-title');

//     if (sidebar && ajaxSidebar) {
//       sidebar.innerHTML = ajaxSidebar.innerHTML;
//     }

//     $(document).on('click', '.CollectionToolbar__Item[data-drawer-id="collection-filter-drawer"]', function() {
//       const button = $(this);
//       overlay.classList.add('is-visible');
//       filterDrawer.setAttribute('aria-hidden', false);
//     });

//     $(document).on('click', '#collection-filter-drawer .Drawer__Close', function() {
//       overlay.classList.remove('is-visible');
//       filterDrawer.setAttribute('aria-hidden', true);
//     });

//     $(document).on('click', '.CollectionFilters__ClearButton', function() {
//       const cmsData = $('.collection-template-cms__data');
//       const cmsUrl = cmsData.attr('data-cms-query');
//       const newCmsUrl = cmsUrl.replace(/\?.*$/, '');

//       window.location.href = newCmsUrl;
//     });

//     $(document).on('change', '.collection-filters-form .Linklist__Item .Linklist__Checkbox', function() {
//       const checkbox = $(this);
//       const form = checkbox.parents('.collection-filters-form');
      
//       const cmsData = $('.collection-template-cms__data');
//       const cmsUrl = cmsData.attr('data-cms-query');

//       const newCmsUrl = cmsUrl.replace(/\?.*$/, '') + '?' + form.serialize();
//       window.location.href = newCmsUrl;
//     });

//     $(document).on('change', '.collection-filters-form .price-range .input-prefix__field', function() {
//       const input = $(this);
//       const form = input.parents('.collection-filters-form');
      
//       const cmsData = $('.collection-template-cms__data');
//       const cmsUrl = cmsData.attr('data-cms-query');

//       const newCmsUrl = cmsUrl.replace(/\?.*$/, '') + '?' + form.serialize();
//       window.location.href = newCmsUrl;
//     });

//     $(document).on('click', '.PageOverlay', function() {
//       overlay.classList.remove('is-visible');
//       sorting.setAttribute('aria-hidden', true);
//     });
//   },
//   sorting: function(ajaxContent) {
//     const overlay = document.querySelector('.PageOverlay');
    
//     var sorting = document.querySelector('#collection-sort-popover');
//     const ajaxSorting = ajaxContent.querySelector('#collection-sort-popover');

//     if (sorting && ajaxSorting) {
//       sorting.innerHTML = ajaxSorting.innerHTML;
//     }

//     $(document).on('click', '.CollectionToolbar__Item[aria-controls="collection-sort-popover"]', function() {
//       var sorting = document.querySelector('#collection-sort-popover');

//       if ($(window).width() < 1008) {
//         overlay.classList.add('is-visible');
      
//       } else {
//         sorting.style.top = '341px';
//         sorting.style.right = 0;

//         setTimeout(function() {
//           sorting.setAttribute('aria-hidden', true);
//         }, 5000);
//       }

//       var sorting = document.querySelector('#collection-sort-popover');
//       sorting.setAttribute('aria-hidden', false);
//     });

//     $(document).on('click', '#collection-sort-popover .Popover__Close', function() {
//       overlay.classList.remove('is-visible');
//       sorting.setAttribute('aria-hidden', true);
//     });

//     $(document).on('click', '#collection-sort-popover .Popover__Value', function() {
//       const item = $(this);

//       const cmsData = $('.collection-template-cms__data');
//       const cmsUrl = cmsData.attr('data-cms-query');
      
//       const newCmsUrl = cmsUrl + (/\?/.test(cmsUrl) ? '&' : '?') + 'sort_by=' + item.attr('data-value');
//       window.location.href = newCmsUrl;
//     });
    
//     $(document).on('click', '.PageOverlay', function() {
//       overlay.classList.remove('is-visible');
//       sorting.setAttribute('aria-hidden', true);
//     });
//   },
//   products: function(ajaxContent) {
//     const collectionData = document.querySelector('.collection-template-cms__data');
    
//     const products = document.querySelector('.CollectionInner__Products');
//     const ajaxProducts = ajaxContent.querySelector('.CollectionInner__Products');

//     const ajaxProductsHeading = ajaxProducts.querySelector('.ProductListHeading');

//     if (ajaxProductsHeading) {
//       ajaxProductsHeading.innerHTML = collectionData.getAttribute('data-title');
//     }

//     const breadcrumbTitle = ajaxProducts.querySelector('#seo-breadcrumbs > div:last-child > li > a > span');

//     if (breadcrumbTitle) {
//       breadcrumbTitle.innerHTML = collectionData.getAttribute('data-title');
//     }

//     const ajaxProductsItems = ajaxProducts.querySelectorAll('.ProductItem');

//     if (ajaxProductsItems) {

//       for (var i = 0; i < ajaxProductsItems.length; i++) {
//         const ajaxProductItem = ajaxProductsItems[i];
//         ajaxProductItem.style.visibility = 'inherit';
//         ajaxProductItem.style.opacity = 1;
//         ajaxProductItem.style.transform = 'matrix(1, 0, 0, 1, 0, 0)';
//       }
//     }

//     if (products && ajaxProducts) {
//       products.innerHTML = ajaxProducts.innerHTML;
//     }
//   }
// };

// if (document.body.classList.contains('template-collection')) {
//   window.themeObj.collectionPage.init();
// }
/* /Collection CMS (Efficient Metrics) */

jQuery(document).ready(function(){
jQuery(window).scroll(function(){
    $("facets-sort-popover").hide()
});
});